// @TODO: <HEALTH2019>
(function () {
    App.factory('ZochaFileSharingService', ZochaFileSharingFactory);
    ZochaFileSharingFactory.$inject = ['Config', 'baseService'];

    function ZochaFileSharingFactory(Config, baseService) {
        return new ZochaFileSharingService();

        function ZochaFileSharingService() {
            this.fetchFilesList = function (page) {
                var url = Config.API_URL + '/zocha/fileSharing/list?pageNumber=:pageNumber&pageSize=10';
                url = url.replace(/:pageNumber/g, page);
                return baseService.get(url);
            };

            this.uploadFile = function (file) {
                return baseService.postFile(Config.API_URL + '/zocha/fileSharing/upload', file);
            };

            this.downloadFile = function (fileId) {
                var url = Config.API_URL + '/zocha/fileSharing/:fileId/download';
                url = url.replace(/:fileId/g, fileId);

                return baseService.download(url, undefined);
            }
        }
    }
})();
// @TODO: </HEALTH2019>
